exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.tips[data-v-1661d2ac] {\r\n  color: #999;\r\n  font-size: 12px;\r\n  margin-top: 6px;\n}\n.img[data-v-1661d2ac] {\r\n  margin-left: 10px;\n}\r\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/distribution/setting.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB","file":"setting.vue","sourcesContent":["\n.tips[data-v-1661d2ac] {\r\n  color: #999;\r\n  font-size: 12px;\r\n  margin-top: 6px;\n}\n.img[data-v-1661d2ac] {\r\n  margin-left: 10px;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1661d2ac","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/distribution/setting.vue
// module id = IBFp
// module chunks = 0